import {
  useCandidateQueryWatchStore,
  type CandidateQueryWatch,
} from '@/entities/outreach-candidate';
import { useCandidateQueryCompletionNotice } from '../model/candidateQueryWatch';

function Watch({ entry }: { entry: CandidateQueryWatch }) {
  useCandidateQueryCompletionNotice(entry);
  return null;
}

/**
 * 앱 뿌리에 서서, 후보 선택 면이나 캠페인 상세 덮개가 닫혀 있어도 지켜보던 후보 조회가
 * 끝나는 순간 나라별로 알린다. 지켜볼 조회는 후보 선택 면이 담는다.
 */
export function CandidateQueryCompletionWatcher() {
  const watches = useCandidateQueryWatchStore((st) => st.watches);
  return (
    <>
      {watches.map((entry) => (
        <Watch key={entry.queryId} entry={entry} />
      ))}
    </>
  );
}
